import { motion } from "motion/react";
import {
  Cloud,
  Server,
  Database,
  Lock,
  Zap,
  BarChart3,
} from "lucide-react";

export function TecnologiaPage() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="py-24 px-6 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Arquitetura{" "}
              <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                cloud-native
              </span>{" "}
              moderna
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Infraestrutura de missão crítica projetada para
              alta disponibilidade, performance e escalabilidade
              infinita
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: Cloud,
                title: "AWS Cloud Infrastructure",
                desc: "Multi-region deployment com CDN global e auto-scaling automático",
              },
              {
                icon: Server,
                title: "Microserviços Resilientes",
                desc: "Arquitetura distribuída com failover automático e circuit breakers",
              },
              {
                icon: Database,
                title: "Data Infrastructure",
                desc: "Bancos de dados relacionais e NoSQL para alta performance",
              },
              {
                icon: Lock,
                title: "Security by Design",
                desc: "Criptografia end-to-end, MFA, RBAC e compliance total",
              },
              {
                icon: Zap,
                title: "Event-Driven Architecture",
                desc: "Processamento assíncrono e real-time com alta throughput",
              },
              {
                icon: BarChart3,
                title: "Observabilidade Total",
                desc: "Monitoramento em tempo real, logs centralizados e APM",
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -4 }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-blue-500 rounded-xl flex items-center justify-center mb-6">
                  <item.icon className="w-7 h-7 text-white" />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Infraestrutura{" "}
            <span className="text-green-600">
              enterprise-grade
            </span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {[
              { value: "99.9%", label: "Uptime SLA" },
              { value: "<100ms", label: "Latência média" },
              { value: "24/7", label: "Suporte técnico" },
            ].map((stat, i) => (
              <motion.div
                key={i}
                className="bg-white rounded-2xl p-8 shadow-sm"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <div className="text-5xl font-bold text-green-600 mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}